import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config';
import attentionIcon from '../../images/attention-icon.svg';
import { goToPage } from '../../SpeedTestAndDisconnectionsWizardBlockSlice';
import { restartDevice } from '../../SpeedTestAndDisconnectionsWizardBlockThunk';

const AutomaticRouterInitializationPage = (props) => {
const routerImage = props.router?.image;

function onclickBtn(){
    props.restartDevice();
    props.goToPage({ page: 'LoaderPage' })
}

  return (
      <div className='automatic-router-initialization-page'>
        <div className='content-wrapper'>
        {routerImage && <Image className='icon' src={Config.epiBaseUrl + routerImage} alt={'router image'} /> }
        {props.automaticInitializationPage.title && <h1 className='title'>{props.automaticInitializationPage.title}</h1>}
        {props.automaticInitializationPage.subTitle && <h1 className='sub-title'>{props.automaticInitializationPage.subTitle}</h1>}
        {props.automaticInitializationPage.attentionText && <div className='attention-text-wrapper'><Image src={attentionIcon} alt='attention icon' /><div className='text'>{props.automaticInitializationPage.attentionText}</div></div> }
        </div>
        <div className='buttons-wrapper'>
            {props.automaticInitializationPage.buttonText && (
            <BtnSubmit text={props.automaticInitializationPage.buttonText} onclick={() => onclickBtn()} formid={'automatic-router-initialization-page'} />
            )}
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    automaticInitializationPage: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.automaticInitializationPage,
    router: state.speedTestAndDisconnectionsWizardBlock.router
  };
};

const mapDispatchToProps = {goToPage, restartDevice};

export default connect(mapStateToProps, mapDispatchToProps)(AutomaticRouterInitializationPage);
